import lodash from 'lodash'
import { contractorPermsTypes } from '@/utils/aclHelper'
import store from '@/store/index'
import i18n from '@/utils/i18n'
import userHelper from '@/utils/userHelper'
import { getVendorDetailByIdAndSite } from '../users/request'
import { getPurchaseNumber } from '../projects/util'
import { getPrimaryEmail } from '../users/util'
import { getVendorSubEmailsByRight } from './util'
import { getProjectAccounts } from '../projects/request'

export async function getEmailDetailForProject (vendorId, siteCode) {
  const [vendorDetail, vendorSubAccounts] = await getVendorDetailByIdAndSite(vendorId, siteCode)
  const subAccountEmails = getVendorSubEmailsByRight(vendorSubAccounts, contractorPermsTypes.projects.readUpdate)
  return [vendorDetail, subAccountEmails]
}

export async function getMetaData () {
  const currentProject = store.getters['projects/currentProject']
  const siteCode = lodash.get(currentProject, 'site.code')
  const [vendorDetail, subAccountEmails] = await getEmailDetailForProject(currentProject.vendorId, siteCode)
  if (vendorDetail && vendorDetail.email && vendorDetail.enabled) {
    return [currentProject, vendorDetail, subAccountEmails]
  } else {
    const purchase = store.getters['projects/purchase']
    const message = i18n.t('error.sendmail.contactInfoMissing',
      [ lodash.get(purchase, 'company.name') || '' ])
    throw new Error(message)
  }
}

export function buildProjectInfo (project) {
  const purchase = store.getters['projects/purchase']
  const projectInfo = { pic: {} }
  projectInfo.id = project.id
  projectInfo.description = purchase.description
  projectInfo.poNumber = getPurchaseNumber(project.numberType, purchase)
  projectInfo.site = purchase.siteId
  const picEmail = getPrimaryEmail(project.manager)
  const picName = userHelper.getUserName(
    project.manager.username.split('@')[0], lodash.get(project, 'manager.displayName'),
  )
  const picTitle = lodash.get(project, 'manager.title')
  projectInfo.pic.email = picEmail
  projectInfo.pic.name = picName
  projectInfo.pic.title = picTitle

  return projectInfo
}

export async function getProjectRepEmails (projectId) {
  const project = await getProjectAccounts(projectId)
  const emails = project.accounts.map((user) => {
    const email = getPrimaryEmail(user)
    return email || user.username
  })
  return emails
}
